import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { registerWithEmail } from '../../services/authService';
import { extractErrorMessage } from '../../utils/errors';
import { AuthField, AuthLayout, FormError, PasswordField, SubmitButton, authLinkSx } from './AuthLayout';
import { MUTED_TEXT_COLOR } from '../../styles/tokens';

export default function RegisterPage({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return; // без двойной отправки
    if (password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return;
    }
    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setError('');
    setSubmitting(true);
    try {
      await registerWithEmail(email.trim(), password);
      await onSuccess();
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Регистрация" onSubmit={handleSubmit}>
      <AuthField
        id="register-email"
        label="Email"
        type="email"
        inputMode="email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        autoComplete="email"
        required
      />
      <PasswordField
        id="register-password"
        label="Пароль"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        autoComplete="new-password"
        required
      />
      <PasswordField
        id="register-password-confirm"
        label="Повтор пароля"
        value={confirmPassword}
        onChange={(event) => setConfirmPassword(event.target.value)}
        autoComplete="new-password"
        required
      />
      <FormError>{error}</FormError>
      <SubmitButton submitting={submitting}>Зарегистрироваться</SubmitButton>

      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ fontSize: '14px', color: MUTED_TEXT_COLOR }}>
          Уже есть аккаунт?{' '}
          <Link component={RouterLink} to="/login" sx={authLinkSx}>
            Войти
          </Link>
        </Typography>
      </Box>
    </AuthLayout>
  );
}
